import React, { useEffect, useState } from "react"
import Geosuggest from "react-geosuggest"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import ReactSVG from "react-svg"
import CALogo from "../../../images/CA_CheckIcon.svg"
import { isEmpty, min, partition } from "lodash"
import DiscountRibbon from "./DiscountRibbon"
import SelectShops from "./SelectShop"
import ShopFilters from "./ShopFilters"
import { ACTIVE_VIEWS, PRICE } from "../../../shared_component/constants/checkout"
import { DISTANCE } from "../../../v1/components/ShopSearch/SelectShop"
import { RATING_TAG } from "../../../v1/constants/shops"
import MapBox from "../MapBox/MapBox"
import { getInstacartShops } from "../../../v1/actions/instacart"
import store from "../../../shared_component/utils/configureStore"
import Notifications from "../../../v1/components/Notifications"
import { USE_CURRENT_LOCATION } from "../../../v1/constants/mapbox"
import { Dimmer, Loader, Modal } from "semantic-ui-react"
import { routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import {
  gaJSON,
  shopSelectedEvents,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import { getShopAddress, getShopName } from "../../../v1/helpers/shopHelpers"
import { trackEvent } from "../../../shared_component/utils/segmentAnalytics"
import { clearPromotionParam } from "../../../v1/actions/promotion"
import { updateCart, updateInfo } from "../../../v1/actions/user"
import { getActiveVehicle } from "../../../v1/helpers/vehicleHelpers"
import { sortByAttr } from "../../../shared_component/utils/arrayHelpers"
import { suggestGeoSuggestClick } from "../../../v1/CarAdvise2/helpers/geoLocationHelper"

const TOTAL_SHOPS = "32,000"
const ShopSelection = ({
  user,
  history,
  cart,
  activeVehicle,
  promoCode,
  getInstacartShops,
  addedServices,
  updateInfo,
  promotions
}) => {
  const { t } = useTranslation(["instacartShopSelection", "dashboardMapComponent"])

  const [searchLocation, setSearchLocation] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [instacartShops, setInstacartShops] = useState(null)
  const [ratingFiltersApplied, setRatingFilterApplied] = useState([])
  const [typeFiltersApplied, setTypeFilterApplied] = useState([])
  const [sortingType, setSortingType] = useState(PRICE)
  const [isSortOpen, setIsSortOpen] = useState(false)
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [selectedShop, setSelectedShop] = useState(null)
  const [activeView, setActiveView] = useState(ACTIVE_VIEWS.LIST)
  const [open, setOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_preferred_shop_view,
      params: {
        viewType: activeView
      }
    })
  }, [activeView])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_shops_sorting_type,
      params: {
        sortType: sortingType
      }
    })
  }, [sortingType])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_rating_filter_applied,
      params: {
        rating: ratingFiltersApplied
      }
    })
  }, [ratingFiltersApplied])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_type_filter_applied,
      params: {
        filterType: typeFiltersApplied
      }
    })
  }, [typeFiltersApplied])

  const addorRemoveFilterItem = (value, filterType) => {
    if (filterType === RATING_TAG) {
      setRatingFilterApplied((prevRatings) => {
        let updatedRatings = [...prevRatings]
        const index = updatedRatings.findIndex((i) => i === value)

        if (index > -1) {
          updatedRatings = []
        } else {
          updatedRatings = []
          if (value === 2) updatedRatings.push(2, 3, 4, 5)
          else if (value === 3) updatedRatings.push(3, 4, 5)
          else if (value === 4) updatedRatings.push(4, 5)
          else if (value === 5) updatedRatings.push(5)
        }
        return updatedRatings
      })
    } else {
      setTypeFilterApplied((prevTypes) => {
        let updatedTypes = [...prevTypes]
        const index = updatedTypes.findIndex((i) => i === value)

        if (index > -1) {
          updatedTypes.splice(index, 1)
        } else {
          updatedTypes.push(value)
        }
        return updatedTypes
      })
    }
  }

  const clearAllFilters = () => {
    setRatingFilterApplied([])
    setTypeFilterApplied([])
    setIsFilterOpen(false)
  }

  const updateSortingType = (value) => {
    setSortingType(value.length ? value : DISTANCE)
    getFuelStationsDataWithSorting()
  }

  const onGeoSuggestClick = (suggest) => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_select_shop_location_search,
      params: {
        term: suggest.label
      }
    })
    const apiPayload = {
      latitude: suggest?.location?.lat || "41.4248924",
      longitude: suggest?.location?.lng || "-87.7726651"
    }
    setSearchLocation({
      lat: apiPayload.latitude,
      lng: apiPayload.longitude
    })
    fetchShops(apiPayload)
  }

  const servicesParam = () => {
    const services = addedServices.map((sd) => {
      return { position: sd.position, service_definition_id: sd.id }
    })

    return JSON.stringify(services)
  }
  const fetchShops = async (apiPayload) => {
    const activeVehicle = getActiveVehicle()
    setIsLoading(true)
    try {
      const res = await getInstacartShops({
        ...apiPayload,
        vehicle_id: activeVehicle.id,
        services_requested: servicesParam()
      })
      if (res.error || res.result.errors) {
        store.dispatch(
          Notifications.error({
            title: t("settings:errorTitle"),
            message: res.error || res.result.errors,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
        return
      }
      setInstacartShops(res?.result || [])
    } catch (error) {
      console.log("Error in fetchShops", error)
    } finally {
      setIsLoading(false)
    }
  }

  const expandCompressClick = () => {
    setIsSortOpen(false)
    // setIsSortOpenModal(false)
    handleModel()
  }

  const handleModel = () => {
    setOpen((prev) => !prev)
  }

  const handleSearchFuelStation = (suggest) => {
    setSearchLocation({
      lat: suggest?.location?.lat,
      lng: suggest?.location?.lng,
      isUserCurrentLocation: suggest?.name === USE_CURRENT_LOCATION
    })
  }

  const getFuelStationsDataWithSorting = () => {
    let filteredShops = instacartShops?.length > 0 ? [...instacartShops] : []

    // Apply rating filter
    if (!isEmpty(ratingFiltersApplied)) {
      const minRating = +min(ratingFiltersApplied).toFixed(2)
      filteredShops = filteredShops?.filter((shop) => +shop.average_rating >= minRating)
    }

    // Apply type filters
    if (!isEmpty(typeFiltersApplied)) {
      filteredShops = filteredShops.filter((shop) => {
        const { company } = shop || {}
        return (
          (typeFiltersApplied?.includes("walk_in") && company?.walk_ins_only) ||
          (typeFiltersApplied?.includes("appointment") && !company?.walk_ins_only) // Placeholder for additional appointment filtering logic
        )
      })
    }

    if (sortingType === PRICE) {
      let partitioned = partition(
        filteredShops,
        (s) => s?.price_estimates?.[0]?.shop_price_estimate != null
      )
      let withPrices = partitioned[0]
      let nullPrices = partitioned[1]

      let sorted = withPrices?.sort(
        (a, b) =>
          a.price_estimates[0].shop_price_estimate - b.price_estimates[0].shop_price_estimate
      )
      sorted = sorted.concat(sortByAttr(nullPrices, DISTANCE))

      return sorted
    } else {
      return sortByAttr(filteredShops, DISTANCE)
    }
  }

  // useEffect(() => {
  //   suggestGeoSuggestClick()
  // }, [])

  const handleIconClick = (shop) => {
    setSelectedShop(shop)
  }

  const handleShopSelect = async (shop) => {
    if (!user.lastName || !user.zip) {
      await updateInfo({
        zip: !user.zip ? shop.zip : user.zip,
        lastName: !user.lastName ? "" : user.lastName
      })
    }
    setIsSubmitting(true)
    let opts = {
      successCallback: async (response) => {
        await shopSelectedEvents({ response, shop, activeVehicle })
        await trackEvent("click-service-center", {
          shopAddress: getShopAddress(response.shop),
          shopCity: response.shop && response.shop.city,
          shopName: getShopName({
            shop: response.shop,
            company: response.shop && response.shop.company
          }),
          shopId: response.shop && parseInt(response.shop.id),
          eventSourceName: "Checkout_2.0"
        })
        store.dispatch(clearPromotionParam())
      }
    }
    if (promoCode) opts.promoCode = promoCode

    const response = await store.dispatch(
      updateCart([{ event: "set_shop", shop_id: shop.id }], undefined, undefined, true, opts)
    )

    if (response && response().result) {
      setSelectedShop(shop)
      setIsSubmitting(false)
      history.push({
        pathname: routerPaths.appointment
      })
    }
    if (response().error) {
      setSelectedShop(null)
      setIsSubmitting(false)
    }
  }

  const onLocationPermissionError = () => {
    store.dispatch(
      Notifications.error({
        title: t("settings:errorTitle"),
        message: "Location permission is needed to continue. Please enable it in settings.",
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    )
  }

  return (
    <div
      className={`instacart-shop-selection ${isEmpty(instacartShops) ? "" : "shop-section-height"}`}
    >
      <div className="section-sticky">
        {activeView !== ACTIVE_VIEWS.MAP && (
          <p className="search-by">{t("searchNearByOilShops")}</p>
        )}

        {activeView !== ACTIVE_VIEWS.MAP && (
          <Geosuggest
            onSuggestSelect={(suggest) =>
              suggestGeoSuggestClick(suggest, onGeoSuggestClick, onLocationPermissionError)
            }
            placeholder={t("geoPlaceholder")}
            types={["geocode"]}
            country={user.country}
            ignoreTab={true}
            className="geosuggestContainerNew shop-selection"
            suggestsClassName="search-suggests-list"
            suggestItemClassName="search-suggest-item"
            inputClassName={`searchFldShop smaller-width`}
            suggestItemActiveClassName="search-suggest-item-active"
            suggestsHiddenClassName="search-suggests-list-hidden"
            fixtures={[{ label: t("dashboardMapComponent:use-current-location"), custom: true }]}
          />
        )}

        {/* Shop Filters */}
        {instacartShops && (
          <div
            className={`instacart-shop-filters-box ${
              activeView === ACTIVE_VIEWS.MAP ? "instacart-shop-filters-box-map" : ""
            } `}
          >
            <ShopFilters
              setActiveView={setActiveView}
              activeView={activeView}
              ratingFiltersApplied={ratingFiltersApplied}
              typeFiltersApplied={typeFiltersApplied}
              addorRemoveFilterItem={addorRemoveFilterItem}
              clearAllFilters={clearAllFilters}
              sortingType={sortingType}
              setIsSortOpen={setIsSortOpen}
              setIsFilterOpen={setIsFilterOpen}
              isSortOpen={isSortOpen}
              isFilterOpen={isFilterOpen}
              updateSortingType={updateSortingType}
              setSelectedShop={setSelectedShop}
              setSortingType={setSortingType}
            />
          </div>
        )}

        {instacartShops && promotions.length > 0 && (
          <div className="discount-ribbon-container">
            <DiscountRibbon title={t("discountOnCheckout")} />
          </div>
        )}
      </div>

      {/* Shop list and Map view */}
      <div
        className={`instacart-shop-selection-list ${
          !isLoading && instacartShops && instacartShops.length === 0 ? "no-shops-found" : ""
        }`}
      >
        {activeView === ACTIVE_VIEWS.LIST ? (
          getFuelStationsDataWithSorting()?.map((shop) => (
            <SelectShops
              handleShopSelection={handleShopSelect}
              key={shop.id}
              selectedShop={selectedShop}
              shop={shop}
              isSubmitting={isSubmitting}
            />
          ))
        ) : (
          <MapBox
            shops={instacartShops || []}
            isLoading={isLoading}
            expandCompressClick={expandCompressClick}
            onSuggestSelect={handleSearchFuelStation}
            searchLocation={searchLocation}
            handleIconClick={handleIconClick}
            selectedItem={selectedShop}
            isShopSelection={true}
            mapSelectComponent={
              <SelectShops
                handleShopSelection={handleShopSelect}
                shop={selectedShop}
                selectedShop={selectedShop}
                isSubmitting={isSubmitting}
              />
            }
          />
        )}
        {!isLoading && instacartShops && instacartShops.length === 0 && <p>{t("noShopsFound")}</p>}
      </div>

      {/* Placeholder */}
      {(isLoading || !instacartShops) && (
        <div className="shop-selection-placeholder">
          <ReactSVG className={`ca-logo ${isLoading ? "ca-logo-loading" : ""}`} src={CALogo} />
          <p className="placeholder-text">
            {isLoading
              ? t("lookingForBestDeals")
              : t("searchShops", {
                  SHOPS: TOTAL_SHOPS
                })}
          </p>
        </div>
      )}

      {open && (
        <Modal
          open={open}
          onClose={handleModel}
          onOpen={handleModel}
          className="fuel-station-modal"
        >
          <div className="modal-container">
            <div className="fuel-station-box">
              <div className="shop-list-section">
                {getFuelStationsDataWithSorting()?.map((shop) => (
                  <SelectShops
                    handleShopSelection={handleShopSelect}
                    key={shop.id}
                    selectedShop={selectedShop}
                    shop={shop}
                    isSubmitting={isSubmitting}
                  />
                ))}
              </div>
              <div className="map-box-section">
                <MapBox
                  shops={instacartShops || []}
                  isLoading={isLoading}
                  isExpanded={open}
                  isShopSelection={true}
                  containerClassName="map-modal"
                  wantExpandCollapse={false}
                  expandCompressClick={expandCompressClick}
                  onSuggestSelect={handleSearchFuelStation}
                  searchLocation={searchLocation}
                  handleIconClick={handleIconClick}
                  selectedItem={selectedShop}
                  mapSelectComponent={
                    <SelectShops
                      handleShopSelection={handleShopSelect}
                      shop={selectedShop}
                      selectedShop={selectedShop}
                      isSubmitting={isSubmitting}
                    />
                  }
                />
              </div>
            </div>
          </div>
          {isSubmitting && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
        </Modal>
      )}

      {isSubmitting && (
        <Dimmer className="shop-select-dimmer" active>
          <Loader />
        </Dimmer>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  let user = state.user
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  let cart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  let addedServices = cart ? cart.order_services : []
  const promotionData = state.promotionData

  return {
    addedServices,
    promoCode: promotionData.promoCode,
    user,
    cart: cart || {},
    activeVehicle,
    promotions: promotionData.customerPromotions || []
  }
}

export default withRouter(
  connect(mapStateToProps, { getInstacartShops, updateInfo })(ShopSelection)
)
